import React from 'react';

const PRODUCTION_ENVIRONMENTS = ['prd', 'prod', 'production'];

const ENVIRONMENT_LABELS: Record<string, string> = {
  uat: 'Ambiente di test (UAT)',
  development: 'Ambiente di sviluppo',
  dev: 'Ambiente di sviluppo',
  staging: 'Ambiente di staging',
};

export function getEnvironment(): string {
  const runtime = (window as { CONFIG?: Record<string, string | undefined> }).CONFIG ?? {};
  return (
    runtime.VITE_ENVIRONMENT ||
    (import.meta.env.VITE_ENVIRONMENT as string | undefined) ||
    'development'
  )
    .trim()
    .toLowerCase();
}

interface EnvironmentBannerProps {
  className?: string;
}

/**
 * Persistent strip shown on every non-production environment.
 * Uses a fixed color (not the tenant primary color) so it stays
 * distinguishable from tenant branding and from the impersonation banner.
 */
export const EnvironmentBanner: React.FC<EnvironmentBannerProps> = ({ className = '' }) => {
  const environment = getEnvironment();
  if (PRODUCTION_ENVIRONMENTS.includes(environment)) return null;

  const label = ENVIRONMENT_LABELS[environment] ?? `Ambiente: ${environment.toUpperCase()}`;

  return (
    <div
      role="status"
      data-testid="environment-banner"
      className={`flex items-center justify-center gap-2 bg-orange-600 px-4 py-1 text-xs font-semibold uppercase tracking-wide text-white ${className}`}
    >
      <span className="rounded bg-white/20 px-1.5 py-0.5">{environment.toUpperCase()}</span>
      <span className="truncate">{label} — non è l'ambiente di produzione</span>
    </div>
  );
};

export default EnvironmentBanner;
